export default __webpack_public_path__ + "static/media/faci02.de377dc9.jpg";